import { Row } from "antd";
import React, { Component } from "react";

export default class UserCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    let { title, userData, colClass,onEdit=(()=>('')) } = this.props;
    let { pencilplus } = imagepaths;
    return (
      <>
        <div className="container-fluid paper_container mb-4">
          <div className="card profile_card">
            <div className="card-header">
              <h5 className="card-title">{title}</h5>
              <button className="edit_btn" onClick={()=>onEdit()} data-bs-toggle="modal" data-bs-target="#appModal">
                <span className="cursor-pointer text-black">
                  <img src={pencilplus} />
                </span>
              </button>
            </div>
            <div className="card-body">
              <Row className="custom_list_group mx-0">
                <AppColFields data={userData} colClass={colClass} />
              </Row>
            </div>
          </div>
        </div>
      </>
    );
  }
}
